<div class="component-wrapper">

  <!-- Antragsteller Data Fields-->

  <!-- Project Data Fields-->
  <kendo-expansionpanel class="expansion-panel" [expanded]="true">
    <ng-template kendoExpansionPanelTitleDirective>
      <section-info [overrideTitle]="'review.project.project.title' | translate"
        [attr.aria-label]="'review.project.project.title' | translate"></section-info>
    </ng-template>

    <form [formGroup]="reviewForm.Anfrage.ProjectData">
      <div class="date-pickers">
        <kendo-formfield class="date-picker">
          <div class="d-flex mb-1">
            <kendo-label class="form-label" [for]="projektStart" [text]="'project-data.plannedProjectStart' | translate"
              [infotooltip]="'gutachten.projektdaten.projektstart'">
            </kendo-label>
          </div>
          <kendo-datepicker #projektStart [readonly]="true" [disabled]="true" formControlName="projektStart"
            [appinfotext]="'gutachten.projektdaten.projektstart'" [format]="dateFormat">
          </kendo-datepicker>
        </kendo-formfield>

        <kendo-formfield class="date-picker">
          <div class="d-flex mb-1">
            <kendo-label class="form-label" [for]="projektEnd" [text]="'project-data.plannedProjectEnd' | translate"
              [infotooltip]="'gutachten.projektdaten.projektende'">
            </kendo-label>
          </div>
          <kendo-datepicker #projektEnd formControlName="projektEnd" [readonly]="true" [disabled]="true"
            [appinfotext]="'gutachten.projektdaten.projektende'" [format]="dateFormat">
          </kendo-datepicker>
        </kendo-formfield>
      </div>
      <div class="d-flex mb-1">
        <kendo-label class="form-label" [for]="projektbeschreibung"
          [text]="'project-data.projectDescription' | translate"
          [infotooltip]="'gutachten.projektdaten.projektbeschreibung'">
        </kendo-label>
      </div>
      <div class="richtext-projektbeschreibung-wrapper" #projektbeschreibung
        [innerHTML]="review.anfrage?.projectData?.projektbeschreibung"
        [appinfotext]="'gutachten.projektdaten.projektbeschreibung'">
      </div>
    </form>
  </kendo-expansionpanel>

  <br>
  <kendo-expansionpanel class="expansion-panel">
    <form [formGroup]="reviewForm.Anfrage.ContactData.Institution">
      <ng-template kendoExpansionPanelTitleDirective>
        <section-info [overrideTitle]="'review.project.institution.title' | translate"
          [attr.aria-label]="'review.project.institution.title' | translate">
        </section-info>
      </ng-template>
      <div class="fields-wrapper">
        <kendo-formfield class="name">
          <div class="d-flex mb-1">
            <kendo-label class="form-label" [for]="name" [text]="'institution.organisation.name' | translate"
              [infotooltip]="'gutachten.institution.organisationsname'">
            </kendo-label>
          </div>
          <kendo-textbox #name formControlName="name" showSuccessIcon="initial" showErrorIcon="initial"
            [appinfotext]="'gutachten.institution.organisationsname'" preventEmptyFormatter [maxlength]=100>
          </kendo-textbox>
        </kendo-formfield>
        <div class="organisation-data-rechtsform-ort-wrapper">
          <kendo-formfield class="rechtsform">
            <div class="d-flex mb-1">
              <kendo-label class="form-label" [for]="rechtsform"
                text="{{'institution.organisation.legalForm' | translate}}"
                [infotooltip]="'gutachten.institution.rechtsform'">
              </kendo-label>
            </div>
            <kendo-combobox formControlName="rechtsform" [valuePrimitive]="true" #rechtsform [allowCustom]="false"
              [data]="rechtsformList" [valueField]="'Value'" [appinfotext]="'gutachten.institution.rechtsform'"
              [textField]="'Description'" kendoDropDownFilter>
            </kendo-combobox>
          </kendo-formfield>
          <form [formGroup]="reviewForm.Anfrage.ContactData.Institution.Address">
            <kendo-formfield class="city">
              <div class="d-flex mb-1">
                <kendo-label class="form-label" [for]="city" [text]="'institution.address.city' | translate"
                  [infotooltip]="'gutachten.adresse.ort'">
                </kendo-label>
              </div>
              <kendo-textbox #city formControlName="city" showSuccessIcon="initial" showErrorIcon="initial"
                preventEmptyFormatter [maxlength]=100 appinfotext="gutachten.adresse.ort">
              </kendo-textbox>
            </kendo-formfield>
          </form>
        </div>
      </div>
    </form>
  </kendo-expansionpanel>

  <br>

  <!--Finanzierungsfelder -->
  <kendo-expansionpanel class="expansion-panel">
    <ng-template kendoExpansionPanelTitleDirective>
      <section-info [overrideTitle]="'review.project.finance.title' | translate"
        [attr.aria-label]="'review.project.finance.title' | translate"></section-info>
    </ng-template>

    <form [formGroup]="reviewForm.Anfrage.FinanceData">
      <div class="finance-form">

        <div>
          <kendo-formfield class="numeric-field">
            <kendo-label class="form-label"
              [text]="getFieldLabelByBerechnungsmethode('finance-data.personellcost') | translate"
              [infotooltip]="'gutachten.finanzdaten.personalkosten'">
            </kendo-label>
            <kendo-numerictextbox formControlName="personalmittel" [autoCorrect]="true" [min]="0"
              [format]="currencyFormatOptions" [spinners]="false"
              appinfotext="gutachten.finanzdaten.personalkosten">
            </kendo-numerictextbox>
          </kendo-formfield>

          <kendo-formfield class="numeric-field">
            <kendo-label class="form-label"
              [text]="getFieldLabelByBerechnungsmethode('finance-data.materialcost') | translate"
              [infotooltip]="'gutachten.finanzdaten.sachkosten'">
            </kendo-label>
            <kendo-numerictextbox formControlName="sachmittel" [autoCorrect]="true" [min]="0"
              [format]="currencyFormatOptions" [spinners]="false" appinfotext="gutachten.finanzdaten.sachkosten">
            </kendo-numerictextbox>
          </kendo-formfield>

          <kendo-formfield class="numeric-field">
            <kendo-label class="form-label"
              text="{{getFieldLabelByBerechnungsmethode('finance-data.investmentcost') | translate }}"
              [infotooltip]="'gutachten.finanzdaten.investitionskosten'">
            </kendo-label>
            <kendo-numerictextbox formControlName="investitionsmittel" [autoCorrect]="true" [min]="0"
              [format]="currencyFormatOptions" [spinners]="false"
              appinfotext="gutachten.finanzdaten.investitionskosten">
            </kendo-numerictextbox>
          </kendo-formfield>
        </div>
        <div>
          <kendo-formfield class="numeric-field">
            <kendo-label class="form-label"
              [text]="getFieldLabelByBerechnungsmethode('finance-data.equitycapital') | translate"
              infotooltip="gutachten.finanzdaten.eigenmittel">
            </kendo-label>
            <kendo-numerictextbox formControlName="eigenmittel" [autoCorrect]="true" [min]="0"
              [format]="currencyFormatOptions" [spinners]="false" [appinfotext]="'gutachten.finanzdaten.eigenmittel'">
            </kendo-numerictextbox>
          </kendo-formfield>

          <kendo-formfield class="numeric-field">
            <kendo-label class="form-label"
              [text]="getFieldLabelByBerechnungsmethode('finance-data.thirdPartyFunds') | translate"
              [infotooltip]="'fgutachten.inanzdaten.drittmittel'">
            </kendo-label>
            <kendo-numerictextbox formControlName="drittmittel" [autoCorrect]="true" [min]="0"
              [format]="currencyFormatOptions" [spinners]="false" appinfotext="gutachten.finanzdaten.drittmittel">
            </kendo-numerictextbox>
          </kendo-formfield>
        </div>
      </div>
      <div [class]="reverseCalculationRow ? 'display-form-reverse' : 'display-form'">
        <kendo-formfield class="foerdersumme">
          <kendo-label class="form-label"
            text="{{getFieldLabelByBerechnungsmethode('finance-data.requestedFunding') | translate}}"
            [infotooltip]="'gutachten.finanzdaten.angefragtefoerdersumme'">
          </kendo-label>
          <kendo-numerictextbox formControlName="foerdersumme" [readonly]="true" [format]="currencyFormatOptions"
            [disabled]="true" [spinners]="false" [appinfotext]="'gutachten.finanzdaten.angefragtefoerdersumme'">
          </kendo-numerictextbox>
        </kendo-formfield>
        <form [formGroup]="financeDataDisplayForm">
          <kendo-formfield class="gesamt">
            <kendo-label class="form-label"
              text="{{getFieldLabelByBerechnungsmethode('finance-data.totalCost') | translate}}"
              [infotooltip]="'gutachten.finanzdaten.gesamtkosten'">
            </kendo-label>
            <kendo-numerictextbox formControlName="gesamt" [readonly]="true" [format]="currencyFormatOptions"
              [disabled]="true" [spinners]="false" [appinfotext]="'gutachten.finanzdaten.gesamtkosten'">
            </kendo-numerictextbox>
          </kendo-formfield>
        </form>
      </div>
    </form>
  </kendo-expansionpanel>

  <br>
  <!--Anlagen-->

  <kendo-expansionpanel class="expansion-panel">
    <ng-template kendoExpansionPanelTitleDirective>
      <section-info [overrideTitle]="'review.project.attachments.title' | translate"
        [attr.aria-label]="'review.project.attachments.title' | translate">
      </section-info>
    </ng-template>
    <div class="attachments-wrapper">
      <div class="wrapper-content-attachment p-2">
        <span class="document-name form-label" translate>document.name</span>
        <span class="document-size form-label" translate>document.size</span>
        <div class="buttons">
          <button *ngIf="documents !=null && documents.length> 0" [title]="'document.download.aszip' | translate"
            kendoButton class="download-as-zip-button" (click)="onDownloadDocumentsAsZipClick()" translate><i></i>
            </button>
        </div>
      </div>
    </div>

    <div class="attachments-wrapper">
      <div class="document-view-item" *ngFor="let document of documents; let index = index;">
        <div class="wrapper-content-attachment p-2">
          <span class="document-name">{{document.name}}</span>
          <span class="document-size">{{documentSize(document)}}</span>
          <div class="buttons">
            <button [title]="'document.download' | translate" kendoButton class="download-button"
              (click)="onDownloadDocumentClick(document)" translate><i></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </kendo-expansionpanel>
</div>